module.exports = __webpack_public_path__ + "assets/f44cb7b3e03a64a1454c85a34c108c03.png";